import { routes as coreRoutes } from 'Core/routes';
import { routes as easyCreditRoutes } from 'Modules/easyCredit/routes';

export const routes = {
  us: [
    ...coreRoutes,
    ...easyCreditRoutes,
  ],
  de: [
    ...coreRoutes,
    ...easyCreditRoutes,
  ],
};
